'use client';

import { JourneyTopBarLoader } from '~/components/Journey/loaders/JourneyTopBarLoader';
import { TopBarLoadingFallback } from '~/components/PartnerLoader/TopBarLoadingFallback';
import { isTripV2Enabled } from '~/utils/tripV2Flag';

const JourneyLoading = () => (isTripV2Enabled() ? <TopBarLoadingFallback /> : <JourneyTopBarLoader />);

export default JourneyLoading;
